<template>
    <div class="recycle-order-detail-container">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator="/" style="margin-bottom: 20px;">
        <el-breadcrumb-item :to="{ path: '/recycle/order' }">桶内回收订单</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
  
      <!-- 加载状态 -->
      <div v-loading="loading" style="min-height: 600px;">
        <!-- 订单基础信息卡片 -->
        <el-card class="info-card" shadow="hover">
          <div slot="header" class="card-header">
            <span>订单基础信息</span>
            <span class="order-no-tag">订单编号：{{ detailData.orderNo || '-' }}</span>
          </div>
  
          <el-form label-width="120px" :model="detailData" class="info-form">
            <el-row :gutter="16">
              <!-- 订单ID -->
              <el-col :span="12">
                <el-form-item label="订单号">
                  <span class="info-text">{{ detailData.deviceNo || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户手机号">
                  <span class="info-text">{{ detailData.phone || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回收机名称">
                  <span class="info-text">{{ detailData.deviceName || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回收机点位地址">
                  <span class="info-text">{{ detailData.deviceAddress || '-' }}</span>
                </el-form-item>
              </el-col>
              <!-- 回收类型 -->
              <el-col :span="12">
                <el-form-item label="回收类型">
                  <el-tag size="medium">可回收物</el-tag>
                </el-form-item>
              </el-col>
              <!-- 重量 -->
              <el-col :span="12">
                <el-form-item label="重量(kg)">
                  <span class="info-text">{{ detailData.weight || 0 }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单价(元/kg)">
                  <span class="info-text">{{ detailData.unitPrice || 0 }}</span>
                </el-form-item>
              </el-col>
              <!-- 金额 -->
              <el-col :span="12">
                <el-form-item label="金额(元)">
                  <span class="info-text">{{ (detailData.totalPrice || 0).toFixed(2) }}</span>
                </el-form-item>
              </el-col>
              <!-- 创建时间 -->
              <el-col :span="12">
                <el-form-item label="创建时间">
                  <span class="info-text">{{ formatTime(detailData.createTime) || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单状态">
                  <el-tag size="medium">{{ detailData.status === 1 ? '审核中' : detailData.status === 2 ? '已完成' : '已拒绝' }}</el-tag>
                </el-form-item>
              </el-col>
              <!-- 关联设备 -->
              <el-col :span="12">
                <el-form-item label="关联设备">
                    {{detailData.deviceNo}}
                  <span class="info-text">{{ detailData.deviceName || '-' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
  
        <!-- 回收图片展示卡片 -->
        <el-card class="img-card" shadow="hover" style="margin-top: 20px;">
          <div slot="header" class="card-header">
            <span>桶内图片</span>
          </div>
  
          <div class="img-list">
            <!-- 无图片 -->
            <div v-if="!detailData.insidePicUrl || detailData.insidePicUrl.length === 0" class="img-placeholder">
              <el-empty description="暂无回收物料图片" />
            </div>
            <!-- 单张/多张图片 -->
            <div v-else class="img-grid">
              <el-image
                v-for="(url, index) in detailData.insidePicUrl"
                :key="index"
                :src="url"
                fit="cover"
                style="width: 200px; height: 200px; margin: 0 10px 10px 0; border-radius: 4px;"
                :preview-src-list="detailData.insidePicUrl"
              />
            </div>
          </div>
        </el-card>
        <el-card class="img-card" shadow="hover" style="margin-top: 20px;">
          <div slot="header" class="card-header">
            <span>桶外图片</span>
          </div>
  
          <div class="img-list">
            <!-- 无图片 -->
            <div v-if="!detailData.outsidePicUrl|| detailData.outsidePicUrl.length === 0" class="img-placeholder">
              <el-empty description="暂无回收物料图片" />
            </div>
            <!-- 单张/多张图片 -->
            <div v-else class="img-grid">
              <el-image
                v-for="(url, index) in detailData.outsidePicUrl"
                :key="index"
                :src="url"
                fit="cover"
                style="width: 200px; height: 200px; margin: 0 10px 10px 0; border-radius: 4px;"
                :preview-src-list="detailData.outsidePicUrl"
              />
            </div>
          </div>
        </el-card>
      </div>
  
      <!-- 图片预览弹窗 -->
      <el-dialog title="图片预览" :visible.sync="previewVisible" width="70%">
        <img :src="previewImageUrl" style="width: 100%;" />
      </el-dialog>
    </div>
  </template>
  
  <script>
  import moment from 'moment';
  // 引入订单详情接口（根据实际项目路径调整）
  import { getWlRecycleDeviceOrderDetail } from '@/api/recyclingMachine';
  
  export default {
    name: 'RecycleOrderDetail',
    data() {
      return {
        loading: false,
        previewVisible: false,
        previewImageUrl: '',
        detailData: {
          id: '',
          orderNo: '',
          recycleType: '',
          weight: 0,
          totalPrice: 0,
          createTime: '',
          deviceName: '',
          picUrls: [], // 回收图片URL列表
        },
      };
    },
    created() {
      const orderId = this.$route.params.id;
      if (orderId) {
        this.getOrderDetail(orderId);
      }
    },
    methods: {
      // 时间格式化
      formatTime(time) {
        return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-';
      },
  
      // 获取订单详情
      async getOrderDetail(orderId) {
        this.loading = true;
        try {
          const res = await getWlRecycleDeviceOrderDetail({id:Number(orderId)});
          if (res.code === 200) {
            this.detailData = { ...this.detailData, ...res.data };
            // 确保图片列表为数组格式
            if (this.detailData.picUrl && !Array.isArray(this.detailData.picUrls)) {
              this.detailData.picUrls = [this.detailData.picUrl]; // 兼容单张图片字段
            }
          }
        } catch (error) {
          console.error('获取订单详情失败：', error);
          this.$message.error('订单详情加载失败，请重试');
        } finally {
          this.loading = false;
        }
      },
  
      // 预览图片
      previewImage(url) {
        this.previewImageUrl = url;
        this.previewVisible = true;
      },
    },
  };
  </script>
  
  <style scoped>
  .recycle-order-detail-container {
    padding: 20px;
    background: #f7f7f7;
    min-height: calc(100vh - 60px);
  }
  .info-card {
    background: #fff;
    border-radius: 4px;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
  }
  .order-no-tag {
    font-size: 14px;
    color: #666;
    font-weight: normal;
  }
  .info-form {
    padding: 10px 0;
  }
  .info-text {
    font-size: 14px;
    color: #666;
  }
  .img-card {
    background: #fff;
    border-radius: 4px;
  }
  .img-list {
    padding: 10px 0;
  }
  .img-grid {
    display: flex;
    flex-wrap: wrap;
  }
  .img-placeholder {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f8f8;
    border-radius: 4px;
  }
  </style>